import { render } from "./ChangePasswordModal.vue?vue&type=template&id=9c5a6ac0"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=9c5a6ac0&lang=css"
script.render = render

export default script